$(function () {

    if($('#Form_QuoteForm').length != 0){

        $('#Form_QuoteForm').submit(function (e) {
            e.preventDefault();
            let _form = this;
            let hasError = false;

            $(".error-message").remove();
            $(".error").removeClass('error');

       /*     if($("input[name='UserType']:checked").length == 0){
                $('#Form_WarrantyClaimForm_UserType_Holder').addClass('error');
                $('#Form_WarrantyClaimForm_UserType_Holder').append('<div class="error error-message body-copy small">Please select an option</div>');
            }*/

            $('.field.radios-set:visible').each(function () {
                if($(this).find('input[type="radio"]:checked').length == 0){
                    $(this).append('<div class="error error-message body-copy small">Please select an option</div>');
                }
            });

            $("input.requiredInput, select.requiredInput, textarea.requiredInput").each(function(){
                if(!$(this).val()){
                    hasError = true;
                    $(this).addClass('error');
                    let name = $(this).closest('div.requiredInput').find('label').eq(0).html();
                    $(this).after('<div class="error error-message body-copy small">' + name + ' is required</div>');
                }
            });

            if($('.error:visible').length == 0){
                $(".btn-toolbar .error-message").remove();
                $(_form).unbind('submit');
                $(_form).submit();
            }else{
                if(!$(".btn-toolbar .error-message").length){
                    $(".btn-toolbar").append('<div class="error error-message body-copy small form--error">Unable to send – please review the required fields above</div>');
                }
            }
        });


        var input = document.getElementById('Form_QuoteForm_Address');

        var mapOptions = {
            componentRestrictions: {
                country: "nz"
            }
        };
        if(input){
            var autocomplete = new google.maps.places.Autocomplete(input, mapOptions);

            autocomplete.addListener('place_changed', function () {
                var place = autocomplete.getPlace();

                for(var i = 0; i < place.address_components.length; i++){
                    var obj = place.address_components[i];
                    console.log(obj);
                    if(obj.types.includes("sublocality_level_1") || obj.types.includes("sublocality") ){
                        $("#Form_WarrantyClaimForm_Suburb").val(obj.long_name);
                    }
                    if(obj.types.includes("administrative_area_level_1")){
                        $("#Form_WarrantyClaimForm_City").val(obj.long_name);
                    }

                    if(obj.types.includes("postal_code")){
                        $("#Form_WarrantyClaimForm_Postcode").val(obj.long_name);
                    }
                   /* if(obj.types.includes("postal_code")){
                        $("#Form_formSubmit_Postcode").val(obj.long_name);
                    }*/
                }

            });
        }


    }
    //$('.datepicker-input').datepicker();

});
